import { serverApi } from "./http";

export type UpdateCheckResult = {
    currentVersion: string;
    latestVersion: string;
    installerUrl: string;
    releaseNotes: string[];
    message?: string;
};

export type UpdateInstallerDownloadResult = {
    installerUrl: string;
    downloadedPath: string;
    fileName: string;
    size: number;
    launched: boolean;
};

export const checkForAppUpdate = async (): Promise<UpdateCheckResult | null> => {
    try {
        const response = await serverApi.get<UpdateCheckResult>("/api/app/update-check", {
            timeout: 5000,
            validateStatus: (status) => status === 200 || status === 204,
        });

        return response.status === 200 ? response.data : null;
    } catch (error) {
        console.info("update check skipped:", error);
        return null;
    }
};

export const downloadAppUpdateInstaller = async (
    installerUrl: string,
    latestVersion: string
): Promise<UpdateInstallerDownloadResult> => {
    const response = await serverApi.post<UpdateInstallerDownloadResult>(
        "/api/app/download-update-installer",
        { installerUrl, latestVersion },
        { timeout: 180000 }
    );

    return response.data;
};
